import ProductCardGhost from './product-card-ghost'

export default ProductCardGhost
